import dayjs from 'dayjs'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'

import { ONBOARDING_AI_INTERVAL_OPTION_TYPE } from '@/composables/onboarding-ai-step'
import i18n from '@/i18n'

dayjs.extend(quarterOfYear)

export { ONBOARDING_AI_INTERVAL_OPTION_TYPE } from '@/composables/onboarding-ai-step'

export const getOnboardingAiIntervalOptions = () => {
  const quarter = dayjs().quarter()
  const year = dayjs().year()

  const quarterTitle = `Q${quarter} ${year}`
  const annualQuarterlyTitle = `${year} + ${quarterTitle}`

  return [
    {
      type: ONBOARDING_AI_INTERVAL_OPTION_TYPE.ANNUAL_QUARTERLY,
      id: annualQuarterlyTitle,
      title: annualQuarterlyTitle,
      description: i18n.global.t('onboarding.ai.interval.option_annual-quarterly_description')
    },
    {
      type: ONBOARDING_AI_INTERVAL_OPTION_TYPE.QUARTERLY,
      id: quarterTitle,
      title: quarterTitle,
      description: i18n.global.t('onboarding.ai.interval.option_quarterly_description')
    }
  ]
}

export const getDefaultOnboardingAiIntervalId = () => {
  const [annualQuarterlyOption] = getOnboardingAiIntervalOptions()
  return annualQuarterlyOption.id
}
